import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { icoLoaderLight, IconsModule } from '../icons';
import { AutoSpinnerDirective } from './auto-spinner.directive';
import { LoadingIndicatorServiceInitializer } from './loading-indicator.service';
import { SpinnerDirective } from './spinner.directive';

@NgModule({
  declarations: [AutoSpinnerDirective, SpinnerDirective],
  imports: [CommonModule, IconsModule.withIcons(icoLoaderLight)],
  exports: [AutoSpinnerDirective, SpinnerDirective]
})
export class LoadingIndicatorModule {
  static forRoot(): ModuleWithProviders<LoadingIndicatorModule> {
    return {
      ngModule: LoadingIndicatorModule,
      providers: [LoadingIndicatorServiceInitializer]
    };
  }
}
